<div class="bg-white py-36px px-24px rounded-tl-[24px] rounded-tr-[24px]">
	<!-- filter -->
	<app-search-filter
		searchKey="GENERAL_LABELS.SEARCH"
		(keyWord)="orderReturnsFilter.searchText = $event; getOrderReturns()"
		[showFilter]="false"
	></app-search-filter>

	<!-- COUNTRIES -->
	<div
		class="max-w-[406px] flex justify-evenly items-center py-[8px] max-mobile:p-0 px-[10px] bg-off-white rounded-[50px] text-dark-grey mt-[18px] text-font-16 cursor-pointer border-secondry-color-Gray border-[1px]"
	>
		<a
			routerLink="/layout/order-return"
			[queryParams]="{ country: country.id }"
			*ngFor="let country of activeCountries"
			class="text-center w-[55%] max-mobile:m-[3px]"
			[ngClass]="{ activeClass: orderReturnsFilter.countryId == country.id }"
		>
			<!-- prettier-ignore -->
			<img class="inline-block w-[24px] max-mobile:hidden max-mobile:w-full max-mobile:text-font-mobile-small"
                [src]="attachementUrl + country.flagUrl" alt="" />
			{{
				this.translate.currentLang === 'ar'
					? country?.name?.ar
					: country?.name?.en
			}}
		</a>
	</div>
	<!-- prettier-ignore -->
	<!-- tabs -->
	<div class="my-[18px] overflow-auto">
		<app-tabs
			[taps]="returnStatus"
			[activeTap]="orderReturnsFilter.returnStatus || 1"
			(tapChanged)="tapChanged($event)"
		></app-tabs>
	</div>

	<!-- table -->
	<app-order-returns-table
		[orderReturns]="orderReturns"
		[orderReturnsFilter]="orderReturnsFilter"
		[totalCount]="totalCount"
	></app-order-returns-table>
</div>
<app-no-data-found *ngIf="!orderReturns?.length"></app-no-data-found>
<!-- pagination -->
<div class="mt-8 py-5 max-mobile:overflow-auto">
	<app-pagination
		[totalCount]="totalCount"
		[pageNumber]="orderReturnsFilter.paging.pageNumber"
		[pageCount]="orderReturnsFilter.paging.pageSize"
		(currentPage)="pagingChanged($event, orderReturnsFilter.paging.pageSize)"
		(itemsCountPerPage)="pagingChanged(1, $event)"
	></app-pagination>
</div>
